<div class="zero-state-container">
    <h4>{{ errorMessageObservable | async }}</h4>
</div>
